// extracted by mini-css-extract-plugin
export default {"tileItemImgInfo":"TileItemImgInfo_tileItemImgInfo__3oOPe"};